/**
 * Internal dependencies
 */
import { PREFIX_EVENTS_STORE } from '@moderntribe/events/data/utils';

export const SET_INITIAL_STATE = `${ PREFIX_EVENTS_STORE }/VENUE_BLOCK/SET_INITIAL_STATE`;

export const SET_VENUE = `${ PREFIX_EVENTS_STORE }/SET_VENUE`;

export const TOGGLE_VENUE_MAP = `${ PREFIX_EVENTS_STORE }/TOGGLE_VENUE_MAP`;
export const SET_VENUE_MAP = `${ PREFIX_EVENTS_STORE }/SET_VENUE_MAP`;

export const TOGGLE_VENUE_MAP_LINK = `${ PREFIX_EVENTS_STORE }/TOGGLE_VENUE_MAP_LINK`;
export const SET_VENUE_MAP_LINK = `${ PREFIX_EVENTS_STORE }/SET_VENUE_MAP_LINK`;
